import { SVGProps } from 'react';

export const SvgSignal = ({
  score = 0,
  activeColor = '#FEB008',
  inactiveColor = '#FFDF9C',
  ...props
}: SVGProps<SVGSVGElement> & {
  score?: number;
  activeColor?: string;
  inactiveColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={16}
    viewBox="0 0 18 16"
    fill="none"
    {...props}
  >
    <line x1={1.2} y1={10.8} x2={1.2} y2={14.8} stroke={score >= 1 ? activeColor : inactiveColor} strokeWidth={2.4} strokeLinecap="round" />
    <line x1={6.2} y1={7.6} x2={6.2} y2={14.8} stroke={score >= 2 ? activeColor : inactiveColor} strokeWidth={2.4} strokeLinecap="round" />
    <line x1={11.2} y1={4.4} x2={11.2} y2={14.8} stroke={score >= 3 ? activeColor : inactiveColor} strokeWidth={2.4} strokeLinecap="round" />
    <line x1={16.2} y1={1.2} x2={16.2} y2={14.8} stroke={score >= 4 ? activeColor : inactiveColor} strokeWidth={2.4} strokeLinecap="round" />
  </svg>
);
